'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;

var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
// new WebKit
['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'],
// old WebKit (Safari 5.1)
['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];

/* ignore coverage */
function getFullScreenFn() {
  var ret = {};

  for (var i = 0; i < fnMap.length; i += 1) {
    if (fnMap[i][1] in document) {
      for (var j = 0; j < fnMap[i].length; j += 1) {
        ret[fnMap[0][j]] = fnMap[i][j];
      }
      return ret;
    }
  }

  return false;
}

var DesktopFullScreen = function () {
  function DesktopFullScreen(elem, callback) {
    _classCallCheck(this, DesktopFullScreen);

    this._elem = elem;
    this._callback = callback;
    this._fullscreenFn = getFullScreenFn();

    this._bindEvents();
  }

  _createClass(DesktopFullScreen, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      document.addEventListener(this._fullscreenFn.fullscreenchange, this._callback);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      document.removeEventListener(this._fullscreenFn.fullscreenchange, this._callback);
    }
  }, {
    key: 'request',
    value: function request() {
      if (!this.isEnabled) {
        return;
      }

      var request = this._fullscreenFn.requestFullscreen;

      // Work around Safari 5.1 bug: reports support for
      // keyboard in fullscreen even though it doesn't.
      // Browser sniffing, since the alternative with
      // setTimeout is even worse.

      if (/5\.1[.\d]* Safari/.test(navigator.userAgent)) {
        this._elem[request]();
      } else {
        this._elem[request](keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT);
      }
    }
  }, {
    key: 'exit',
    value: function exit() {
      document[this._fullscreenFn.exitFullscreen]();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      delete this._elem;
      delete this._callback;
    }
  }, {
    key: 'isAPIExist',
    get: function get() {
      return Boolean(this._fullscreenFn);
    }
  }, {
    key: 'isInFullScreen',
    get: function get() {
      return Boolean(document[this._fullscreenFn.fullscreenElement]);
    }
  }, {
    key: 'isEnabled',
    get: function get() {
      return Boolean(document[this._fullscreenFn.fullscreenEnabled]);
    }
  }]);

  return DesktopFullScreen;
}();

exports.default = DesktopFullScreen;
//# sourceMappingURL=desktop.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/full-screen/desktop.js
// module id = 1691
// module chunks = 1 2 3